import React, { useState, useEffect } from "react";
import ajaxStationSales from "../../util/remote/ajaxStationSales";
import toast from "react-hot-toast";
export default function BestStationCard() {
  const company_id = Number(localStorage.getItem("FuelFy@company_id"));
  const [station, setStation] = useState(null);
  const [loading, setLoading] = useState(false);
  // Fetch best fuel station
  const fetchBestFuelStation = async () => {
    setLoading(true);
    const data = { company_id: company_id };
    const response = await ajaxStationSales.monthly_best_station(data);
    if (response.status === "OK") {
      setStation(response.details || null);
    } else {
      toast.error(response.message || "Failed to load station data");
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchBestFuelStation();
  }, [company_id]);
  if (loading) {
    return <p>Loading...</p>;
  }
  if (!station) {
    return <p>No station data available</p>;
  }
  return (
    <div className="card-body text-center">
      <div className="station-photo text-center">
        <h6 className="mb-1">Best Performing Station of the Month</h6>
        <img
          alt={station.station_name}
          className="rounded-circle"
          src={process.env.PUBLIC_URL + "/gas station.jpeg"}
          style={{ width: "100px", height: "100px", objectFit: "fill" }}
        />
      </div>
      <h6 className="mb-1 mt-3">{station.station_name}</h6>
      <p className="mb-1 mt-1 tx-inverse">
        Total Sales:{" "}
        <strong>{Number(station.total_amount).toLocaleString()} UGX</strong>
      </p>
      <p className="mb-2 mt-1 tx-inverse">
        Total Litres Sold: <strong>{station.total_quantity} L</strong>
      </p>
      <div className="text-muted text-center mt-0">
        Best performing station based on total litres dispensed
      </div>
    </div>
  );
}
